import classNames from "classnames/dedupe";
import { Image, Text } from "@simplybusiness/mobius";
import windowLocksImage from "./images/window-locks.webp";

export const WindowLocks = () => {
  const classes = classNames("mobius", "mobius-window-locks");

  return (
    <div className={classes}>
      <Text>Examples of these are shown below.</Text>
      <Image src={windowLocksImage} alt="" />
    </div>
  );
};
